<div class="page-layout-container">
  <div class="row">
    <h1 class="title">Monthly Leaves Report</h1>
  </div>
  <div class="row">
    <div class="col-md-auto">
      <mat-form-field>
        <mat-label>Select Month for generating report</mat-label>
        <input
          matInput
          [matDatepicker]="leaveEndDate"
          required
          (dateChange)="fetchMonthlyReport($event)"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="leaveEndDate"
        ></mat-datepicker-toggle>
        <mat-datepicker #leaveEndDate></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="col" *ngIf="empLeavesBalenceList?.length">
      <button mat-button (click)="downLoadSickLeavesReport()">
        Download Sick Leaves withOut Cert Report
      </button>
    </div>
  </div>
  <div class="table-responsive">
    <mat-form-field appearance="standard">
      <mat-label>Filter</mat-label>
      <input
        matInput
        (keyup)="applyFilter($event)"
        placeholder="search with Employee id, name,.."
        #input
      />
    </mat-form-field>

    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
      <ng-container matColumnDef="leaveId">
        <th mat-header-cell *matHeaderCellDef>Leave Id</th>
        <td mat-cell *matCellDef="let element">{{ element.leaveId }}</td>
      </ng-container>

      <ng-container matColumnDef="employeeId">
        <th mat-header-cell *matHeaderCellDef>Employee</th>
        <td mat-cell *matCellDef="let element">{{ element.employeeId }}</td>
      </ng-container>

      <ng-container matColumnDef="leaveType">
        <th mat-header-cell *matHeaderCellDef>Leave Type</th>
        <td mat-cell *matCellDef="let element">{{ element.leaveType }}</td>
      </ng-container>

      <ng-container matColumnDef="startDate">
        <th mat-header-cell *matHeaderCellDef>Start Date</th>
        <td mat-cell *matCellDef="let element">{{ element.startDate }}</td>
      </ng-container>

      <ng-container matColumnDef="endDate">
        <th mat-header-cell *matHeaderCellDef>End Date</th>
        <td mat-cell *matCellDef="let element">{{ element.endDate }}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let element">{{ element.status }}</td>
      </ng-container>

      <ng-container matColumnDef="leaveAppliedBy">
        <th mat-header-cell *matHeaderCellDef>Leave Applied By</th>
        <td mat-cell *matCellDef="let element">{{ element.leaveAppliedBy }}</td>
      </ng-container>

      <ng-container matColumnDef="leaveAppliedDate">
        <th mat-header-cell *matHeaderCellDef>Leave Applied Date</th>
        <td mat-cell *matCellDef="let element">
          {{ element.leaveAppliedDate }}
        </td>
      </ng-container>

      <ng-container matColumnDef="numberOfDays">
        <th mat-header-cell *matHeaderCellDef>Number Of Days</th>
        <td mat-cell *matCellDef="let element">{{ element.numberOfDays }}</td>
      </ng-container>

      <ng-container matColumnDef="comments">
        <th mat-header-cell *matHeaderCellDef>Comments</th>
        <td mat-cell *matCellDef="let element">{{ element.comments }}</td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let element" (click)="deleteLeave(element)">
          <div>
            <button [disabled]="leaveFreezed" mat-button>Delete</button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator
      [pageSizeOptions]="[5, 10, 20]"
      showFirstLastButtons
    ></mat-paginator>
  </div>
</div>
